import { apiFetcher } from '../api-fetcher';

type ReviewStatisticsResponse = {
  data: ReviewData;
}
export type ReviewData = {
  averageGrade:number;
  goodReviewPercentage:number;
  reviewCount:number;
  reviewKeywordStatistics: ReviewKeywordStatistic[];
  guide: {
    title:string;
    contents: string[];
  }
}
type ReviewKeywordStatistic = {
  title:string
  iconUrl:string
  count:number
}

export const getReviewStatistics = async (uid:number) => {
  return apiFetcher.get<ReviewStatisticsResponse>(`/api/review/v2/users/${uid}/reviews-statistics`);
};
